// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3NsvD","productName":"Table_productName__3XUjc"};